<template>
	<div class="relative py-24">
		<div class="container">
			<h2 class="text-brightRed text-lg">Wir blicken zurück</h2>
			<div class="grid grid-cols-1 gap-6 md:grid-cols-3">
				<div>
					<h2 class="mt-0 text-3xl tracking-wide md:text-5xl">Aftermovie</h2>
				</div>
				<div class="md:col-span-2">
					<video
						ref="videoRef"
						controls
						class="w-full cursor-pointer rounded-lg"
						preload="metadata"
						@click="togglePlay"
					>
						<source
							src="https://propellerfestival.de/images/aftermovie_2025.mp4"
							type="video/mp4"
						/>
						Your browser does not support the video tag.
					</video>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
const videoRef = ref<HTMLVideoElement | null>(null)

const togglePlay = () => {
	if (videoRef.value) {
		if (videoRef.value.paused) {
			videoRef.value.play()
		} else {
			videoRef.value.pause()
		}
	}
}
</script>

<style scoped></style>
